import React, { useState, useEffect } from 'react';

const API = 'https://api.financialmind.ai';
const NAVY = '#0a1628', ORANGE = '#c87b2a', GRAY = '#4a5568', CREAM = '#faf7f2', LINE = '#e0d9cf';
const serif = "'Source Serif 4',serif", mono = "'JetBrains Mono',monospace", sans = "'Inter',system-ui,sans-serif";
const STD = [['10', 1490, 0], ['20', 2490, 1], ['40', 3990, 0]];
const ADD = [['10', 690, 0], ['20', 1190, 1], ['40', 1990, 0]];
const F = [
'PD calibrada + trilha das agências (antecipação)',
'Mia CFO e Mia Risk — análise por IA',
'Camada comportamental (bases públicas CVM/CGU)',
'Rating comparável: Fitch, S&P e Moody’s',
'Histórico imutável por período (point-in-time)',
];
const HL = ['Trilha das agências (antecipação)', 'PD calibrada · 5 lentes', 'Mia CFO / Risk (IA)', 'Histórico PIT imutável'];
const brl = (n) => 'R$ ' + n.toLocaleString('pt-BR');
const CK = '✓';
const li = { fontFamily: sans, fontSize: 13, color: '#33404f', paddingLeft: 20, position: 'relative', listStyle: 'none' };
const ADDON_DE = { standalone_10: 'addon_10', standalone_20: 'addon_20', standalone_40: 'addon_40' };
const STANDALONE_DE = { addon_10: 'standalone_10', addon_20: 'standalone_20', addon_40: 'standalone_40' };

// Mensagens dos erros conhecidos do checkout OC (backend: create-checkout-oc)
const ERRO_CHECKOUT = {
plano_oc_invalido: 'Plano inválido. Recarregue a página e tente novamente.',
intervalo_invalido: 'Intervalo de cobrança inválido. Recarregue a página e tente novamente.',
contrato_nao_aceito: 'O aceite do contrato é obrigatório para assinar.',
sem_tenant: 'Sua conta ainda não tem empresa associada. Escreva para contato@financialmind.ai que nós resolvemos.',
dados_obrigatorios: 'Preencha nome, e-mail e empresa.',
contrato_hash_invalido: 'O contrato foi atualizado. Recarregue a página e assine a versão vigente.',
login_necessario_para_addon: 'O Add-on é contratado de dentro da sua conta. Entre e assine por lá.',
};

const inputSt = { width: '100%', boxSizing: 'border-box', border: '1px solid ' + LINE, borderRadius: 8, padding: '11px 12px', fontFamily: mono, fontSize: 13, color: '#1f2937', background: '#faf9f7' };
const lblSt = { fontFamily: sans, fontSize: 12.5, fontWeight: 600, color: '#2d3748', display: 'block', margin: '12px 0 5px' };

// ─── Modal "Assinar Plano" — padrão único do site (igual ao Empresas Fechadas) ───
function AssinarModal({ plan: planInicial, onClose }) {
const [plan, setPlan] = useState(planInicial);
const isStandalone = plan.indexOf('standalone') === 0;
const n = plan.split('_')[1];
const tabela = isStandalone ? STD : ADD;
const preco = (tabela.find((x) => x[0] === n) || tabela[0])[1];
const titulo = (isStandalone ? 'OC Standalone ' : 'OC Add-on ') + n;

const [auth, setAuth] = useState({ st: 'checking', user: null, token: null });
const [ctr, setCtr] = useState({ st: 'loading', data: null });
const [etapa, setEtapa] = useState('inicio'); // inicio | pergunta | cadastro | contrato | addonLogin
const [aceito, setAceito] = useState(false);
const [leuAteAceitar, setLeuAteAceitar] = useState(false);
const [busy, setBusy] = useState(false);
const [err, setErr] = useState('');
const [f, setF] = useState({ name: '', email: '', company: '', cnpj: '', cpf: '', cargo: '' });
const [cnpjInfo, setCnpjInfo] = useState({ loading: false, label: '', razao: '' });
const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

useEffect(() => {
const t = localStorage.getItem('riskmind_token');
if (!t) { setAuth({ st: 'anon', user: null, token: null }); setEtapa('pergunta'); return; }
fetch(API + '/api/auth/me', { headers: { Authorization: 'Bearer ' + t } })
.then((r) => { if (!r.ok) throw new Error('sessao'); return r.json(); })
.then((u) => { setAuth({ st: 'ok', user: u, token: t }); setEtapa('logado'); })
.catch(() => { setAuth({ st: 'anon', user: null, token: null }); setEtapa('pergunta'); });
}, []);

useEffect(() => {
let vivo = true;
setCtr({ st: 'loading', data: null });
setAceito(false); setLeuAteAceitar(false);
fetch(API + '/api/oc/contrato/' + encodeURIComponent(plan))
.then((r) => { if (!r.ok) throw new Error('contrato'); return r.json(); })
.then((d) => { if (vivo) setCtr({ st: 'ok', data: d }); })
.catch(() => { if (vivo) setCtr({ st: 'err', data: null }); });
return () => { vivo = false; };
}, [plan]);

const fmtCNPJ = (v) => v.replace(/\D/g, '').slice(0, 14).replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
const fmtCPF = (v) => v.replace(/\D/g, '').slice(0, 11).replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
async function lookupCNPJ(raw) {
const digits = raw.replace(/\D/g, '');
if (digits.length !== 14) return;
setCnpjInfo({ loading: true, label: '', razao: '' });
try {
const r = await fetch('https://brasilapi.com.br/api/cnpj/v1/' + digits);
if (!r.ok) throw new Error();
const d = await r.json();
const razao = (d.razao_social || '').trim();
if (razao && !f.company) set('company', razao);
setCnpjInfo({ loading: false, label: razao + (d.municipio ? ' — ' + d.municipio + '/' + d.uf : ''), razao });
} catch (e) { setCnpjInfo({ loading: false, label: '', razao: '' }); }
}

// standalone SEM conta: cadastro no checkout (procedimento padrão de compra dos produtos Risk)
async function pagarNovo() {
if (!f.name || !f.email || !f.company) { setErr('Preencha nome, e-mail e razão social.'); return; }
if (!/\S+@\S+\.\S+/.test(f.email)) { setErr('E-mail inválido.'); return; }
if (f.cnpj.replace(/\D/g, '').length !== 14) { setErr('Informe o CNPJ da empresa (obrigatório para NF-e).'); return; }
if (!aceito) { setErr('Assine o contrato para continuar.'); return; }
if (ctr.st !== 'ok') return;
setBusy(true); setErr('');
try {
const rc = await fetch(API + '/api/stripe/create-checkout-oc', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({
plan, interval: 'month', contract_accepted: true, accepted_at: new Date().toISOString(),
contract_hash: ctr.data.hash,
email: f.email, name: f.name, company: f.company,
cnpj_empresa: f.cnpj.replace(/\D/g, ''), cpf: f.cpf.replace(/\D/g, ''),
cargo: f.cargo || 'Administrador',
razao_social: cnpjInfo.razao || f.company,
}),
});
const cj = await rc.json().catch(() => ({}));
if (!rc.ok) throw new Error(cj.message || ERRO_CHECKOUT[cj.error] || cj.error || 'Falha ao criar a sessão de pagamento.');
if (!cj.url) throw new Error('O pagamento não retornou o endereço seguro. Tente novamente.');
window.location.href = cj.url;
} catch (e) { setErr(e.message || 'Erro inesperado. Tente novamente.'); setBusy(false); }
}

// logado (add-on): aceite formal + pagamento
async function pagarLogado() {
if (!aceito) { setErr('Assine o contrato para continuar.'); return; }
if (auth.st !== 'ok' || ctr.st !== 'ok') return;
setBusy(true); setErr('');
const t = auth.token, u = auth.user, d = ctr.data;
try {
const ra = await fetch(API + '/api/oc/contrato/aceite', {
method: 'POST',
headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + t },
body: JSON.stringify({ plan, texto: d.texto, hash: d.hash, nome: u.name, email: u.email, cnpj: u.cnpj || undefined }),
});
const rj = await ra.json().catch(() => ({}));
if (!ra.ok) throw new Error(rj.error ? 'Falha no registro do aceite: ' + rj.error : 'Falha ao registrar o aceite do contrato.');
const rc = await fetch(API + '/api/stripe/create-checkout-oc', {
method: 'POST',
headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + t },
body: JSON.stringify({ plan, interval: 'month', contract_accepted: true, accepted_at: new Date().toISOString() }),
});
const cj = await rc.json().catch(() => ({}));
if (!rc.ok) throw new Error(ERRO_CHECKOUT[cj.error] || cj.error || 'Falha ao criar a sessão de pagamento.');
if (!cj.url) throw new Error('O pagamento não retornou o endereço seguro. Tente novamente.');
window.location.href = cj.url;
} catch (e) { setErr(e.message || 'Erro inesperado. Tente novamente.'); setBusy(false); }
}

const bt = { fontFamily: sans, fontWeight: 700, fontSize: 14, borderRadius: 8, cursor: 'pointer', padding: '13px 22px', border: 'none', width: '100%' };
const btSec = { ...bt, background: '#fff', color: GRAY, border: '1px solid ' + LINE, fontWeight: 600 };
const box = { background: '#fff', borderRadius: 14, width: 'min(560px, 94vw)', maxHeight: '90vh', overflowY: 'auto', padding: '30px 32px', boxShadow: '0 18px 60px rgba(10,22,40,.35)' };
const seloStripe = (
<div style={{ background: '#f4f1ec', borderRadius: 8, padding: '11px 14px', textAlign: 'center', fontFamily: sans, fontSize: 12.5, color: '#4a5568', marginTop: 10 }}>
🔒 Pagamento processado por <b style={{ fontFamily: mono }}>Stripe</b>
</div>
);

// caixa "Ler e assinar Contrato" — padrão do site
const caixaContrato = (
<button onClick={() => { if (ctr.st === 'ok') { setEtapa('contrato'); setErr(''); } }} style={{
width: '100%', boxSizing: 'border-box', marginTop: 16, padding: '13px 14px', borderRadius: 8, cursor: 'pointer',
border: aceito ? '1px solid #1a9e5c' : '1.5px dashed ' + ORANGE, background: aceito ? '#f0faf4' : '#fffdf9',
fontFamily: sans, fontSize: 13.5, fontWeight: 600, color: aceito ? '#1a9e5c' : '#7a4a12', textAlign: 'center',
}}>
{aceito ? CK + ' Contrato assinado — Anexo Carteira Monitorada' : '📄 Ler e assinar Contrato OC '}{!aceito && <span style={{ fontWeight: 400, color: '#a0885f', fontSize: 12 }}>(obrigatório)</span>}
</button>
);

let corpo = null;
if (etapa === 'inicio' || auth.st === 'checking') {
corpo = <div style={{ fontFamily: sans, color: GRAY, padding: '28px 0', textAlign: 'center' }}>Carregando…</div>;
} else if (auth.st === 'ok' && auth.user && auth.user.oc_plan) {
corpo = (
<div>
<p style={{ fontFamily: sans, fontSize: 14, color: '#33404f', lineHeight: 1.65, margin: '4px 0 14px' }}>
Sua conta <b>já tem o RiskMind OC ativo</b> (plano <span style={{ fontFamily: mono }}>{String(auth.user.oc_plan)}</span>). Para ampliar a carteira ou mudar de plano, fale com a gente — assim você não corre o risco de uma segunda cobrança.
</p>
<a href="mailto:contato@financialmind.ai?subject=Upgrade de plano RiskMind OC" style={{ ...bt, background: NAVY, color: '#fff', display: 'block', textAlign: 'center', textDecoration: 'none', boxSizing: 'border-box' }}>Falar com a gente</a>
</div>
);
} else if (etapa === 'pergunta') {
// caixa de diálogo antes (itens 3 e 4): já é cliente Empresas Fechadas?
corpo = (
<div>
<p style={{ fontFamily: sans, fontSize: 15, color: '#1f2937', fontWeight: 600, lineHeight: 1.6, margin: '4px 0 16px' }}>
Você já é cliente RiskMind Empresas Fechadas?
</p>
<div style={{ display: 'grid', gap: 10 }}>
<button onClick={() => { const p = STANDALONE_DE[plan] ? plan : plan; const alvo = ADDON_DE[plan] || plan; setPlan(alvo); setEtapa('addonLogin'); setErr(''); }} style={{ ...bt, background: NAVY, color: '#fff' }}>
Sim, já sou cliente — quero o Add-on ({brl((ADD.find((x) => x[0] === n) || ADD[0])[1])}/mês)
</button>
<button onClick={() => { const alvo = STANDALONE_DE[plan] || plan; setPlan(alvo); setEtapa('cadastro'); setErr(''); }} style={{ ...bt, background: ORANGE, color: '#fff' }}>
Não — contratar agora ({brl((STD.find((x) => x[0] === n) || STD[0])[1])}/mês)
</button>
</div>
<p style={{ fontFamily: sans, fontSize: 12, color: GRAY, lineHeight: 1.6, marginTop: 14 }}>
Cliente Empresas Fechadas contrata o OC como <b>Add-on</b>, integrado ao login e à fatura da conta. Quem ainda não é cliente contrata o <b>Standalone</b> — a conta é criada no próprio checkout.
</p>
</div>
);
} else if (etapa === 'addonLogin' && auth.st === 'anon') {
corpo = (
<div>
<p style={{ fontFamily: sans, fontSize: 14, color: '#33404f', lineHeight: 1.65, margin: '4px 0 16px' }}>
O <b>Add-on</b> é contratado de dentro da sua conta RiskMind. Entre na sua conta (botão <b>Entrar</b>, no topo do site) e clique em <b>Assinar Plano</b> novamente — o contrato e o pagamento seguem por lá.
</p>
<button onClick={() => { onClose(); window.scrollTo({ top: 0, behavior: 'smooth' }); }} style={{ ...bt, background: NAVY, color: '#fff' }}>Ir para o topo (Entrar)</button>
<button onClick={() => setEtapa('pergunta')} style={{ ...btSec, marginTop: 8 }}>Voltar</button>
</div>
);
} else if (etapa === 'contrato') {
// ler e assinar o contrato OC aprovado (anexo da carteira, versão viva do motor)
corpo = ctr.st === 'ok' ? (
<div>
<ul style={{ padding: 0, margin: '0 0 10px', display: 'flex', flexDirection: 'column', gap: 6 }}>
{(ctr.data.destaques || []).map((x, i) => (
<li key={i} style={{ ...li, fontSize: 12.5 }}><span style={{ position: 'absolute', left: 0, color: ORANGE, fontWeight: 700 }}>{CK}</span>{x}</li>
))}
</ul>
<div style={{ border: '1px solid ' + LINE, borderRadius: 8, background: CREAM, padding: '14px 16px', maxHeight: 260, overflowY: 'auto', fontFamily: mono, fontSize: 11, lineHeight: 1.6, whiteSpace: 'pre-wrap', color: '#2a3442' }}>
{ctr.data.texto}
</div>
<div style={{ fontFamily: mono, fontSize: 10, color: '#8a94a1', margin: '8px 2px 0' }}>versão {ctr.data.anexo_versao} · integridade {String(ctr.data.hash || '').slice(0, 23)}…</div>
<label style={{ display: 'flex', gap: 10, alignItems: 'flex-start', margin: '14px 0 6px', cursor: 'pointer' }}>
<input type="checkbox" checked={leuAteAceitar} onChange={(e) => setLeuAteAceitar(e.target.checked)} style={{ marginTop: 3 }} />
<span style={{ fontFamily: sans, fontSize: 13, color: '#33404f', lineHeight: 1.55 }}>Li e aceito o <b>Anexo Contratual — Carteira Monitorada ({ctr.data.anexo_versao})</b> do plano {titulo}, incluindo a regra de trocas por vigência.</span>
</label>
<button onClick={() => { if (leuAteAceitar) { setAceito(true); setEtapa(auth.st === 'ok' ? 'logado' : 'cadastro'); setErr(''); } else { setErr('Marque o aceite para assinar.'); } }} style={{ ...bt, background: leuAteAceitar ? ORANGE : '#a8b0bb', color: '#fff', marginTop: 10 }}>Assinar contrato</button>
{err && <div style={{ fontFamily: sans, fontSize: 13, color: '#b23c17', margin: '8px 0 0', fontWeight: 600 }}>{err}</div>}
<button onClick={() => { setEtapa(auth.st === 'ok' ? 'logado' : 'cadastro'); setErr(''); }} style={{ ...btSec, marginTop: 8 }}>Voltar</button>
</div>
) : ctr.st === 'err' ? (
<div style={{ fontFamily: sans, fontSize: 14, color: '#b23c17', padding: '12px 0' }}>Não foi possível carregar o contrato agora. Tente novamente em instantes ou escreva para contato@financialmind.ai.</div>
) : <div style={{ fontFamily: sans, color: GRAY, padding: '16px 0', textAlign: 'center' }}>Carregando o contrato…</div>;
} else if (etapa === 'cadastro') {
// procedimento padrão de compra dos produtos Risk (igual Empresas Fechadas)
corpo = (
<div>
<label style={lblSt}>Nome completo *</label>
<input style={inputSt} value={f.name} onChange={(e) => set('name', e.target.value)} placeholder="João Silva" />
<label style={lblSt}>CNPJ da Empresa *</label>
<input style={inputSt} value={f.cnpj} onChange={(e) => set('cnpj', fmtCNPJ(e.target.value))} onBlur={(e) => lookupCNPJ(e.target.value)} placeholder="00.000.000/0001-00" />
{cnpjInfo.loading && <div style={{ fontFamily: sans, fontSize: 12, color: GRAY, marginTop: 4 }}>Consultando CNPJ…</div>}
{cnpjInfo.label && <div style={{ fontFamily: sans, fontSize: 12, color: '#1a9e5c', marginTop: 4 }}>{CK} {cnpjInfo.label}</div>}
<label style={lblSt}>Nome / Razão Social *</label>
<input style={inputSt} value={f.company} onChange={(e) => set('company', e.target.value)} placeholder="Preenchido ao informar o CNPJ" />
<div style={{ display: 'flex', gap: 10 }}>
<div style={{ flex: 1 }}>
<label style={lblSt}>CPF do responsável</label>
<input style={inputSt} value={f.cpf} onChange={(e) => set('cpf', fmtCPF(e.target.value))} placeholder="000.000.000-00" />
</div>
<div style={{ flex: 1 }}>
<label style={lblSt}>Cargo / Função</label>
<input style={inputSt} value={f.cargo} onChange={(e) => set('cargo', e.target.value)} placeholder="Ex: Diretor Financeiro" />
</div>
</div>
<label style={lblSt}>E-mail corporativo *</label>
<input style={inputSt} value={f.email} onChange={(e) => set('email', e.target.value)} placeholder="joao@empresa.com.br" type="email" />
{caixaContrato}
{err && <div style={{ fontFamily: sans, fontSize: 13, color: '#b23c17', margin: '10px 0 0', fontWeight: 600 }}>{err}</div>}
<button onClick={pagarNovo} disabled={busy || !aceito} style={{ ...bt, background: busy ? '#8a94a1' : (aceito ? NAVY : '#a8b0bb'), color: '#fff', marginTop: 12 }}>
{busy ? 'Abrindo o pagamento seguro…' : (aceito ? 'Ir para pagamento seguro — ' + brl(preco) + '/mês' : 'Assine o contrato para continuar')}
</button>
<button onClick={onClose} style={{ ...btSec, marginTop: 8 }}>Cancelar</button>
{seloStripe}
</div>
);
} else if (etapa === 'logado' && auth.st === 'ok' && isStandalone) {
// cliente logado escolheu standalone → o caminho do cliente é o Add-on (item 4)
const alt = ADDON_DE[plan];
const altPreco = (ADD.find((x) => x[0] === n) || ADD[0])[1];
corpo = (
<div>
<p style={{ fontFamily: sans, fontSize: 14, color: '#33404f', lineHeight: 1.65, margin: '4px 0 14px' }}>
Você <b>já é cliente RiskMind</b> — para a sua conta o caminho certo é o <b>Add-on</b>: integrado ao seu login e à sua fatura, por <span style={{ fontFamily: mono, fontWeight: 600, color: NAVY }}>{brl(altPreco)}</span>/mês em vez de {brl(preco)}.
</p>
<button onClick={() => { setPlan(alt); setErr(''); }} style={{ ...bt, background: ORANGE, color: '#fff' }}>Contratar o Add-on por {brl(altPreco)}/mês</button>
</div>
);
} else if (etapa === 'logado' && auth.st === 'ok') {
// add-on logado: contrato + pagamento (dados vêm da conta)
corpo = (
<div>
<p style={{ fontFamily: sans, fontSize: 13.5, color: '#33404f', lineHeight: 1.6, margin: '4px 0 2px' }}>
Contratando como <b>{auth.user.company || auth.user.email}</b> — o OC entra no seu login e na sua fatura.
</p>
{caixaContrato}
{err && <div style={{ fontFamily: sans, fontSize: 13, color: '#b23c17', margin: '10px 0 0', fontWeight: 600 }}>{err}</div>}
<button onClick={pagarLogado} disabled={busy || !aceito} style={{ ...bt, background: busy ? '#8a94a1' : (aceito ? NAVY : '#a8b0bb'), color: '#fff', marginTop: 12 }}>
{busy ? 'Abrindo o pagamento seguro…' : (aceito ? 'Ir para pagamento seguro — ' + brl(preco) + '/mês' : 'Assine o contrato para continuar')}
</button>
<button onClick={onClose} style={{ ...btSec, marginTop: 8 }}>Cancelar</button>
{seloStripe}
</div>
);
} else {
corpo = <div style={{ fontFamily: sans, color: GRAY, padding: '20px 0', textAlign: 'center' }}>Carregando…</div>;
}

return (
<div onClick={onClose} role="dialog" aria-modal="true" style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,.62)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
<div onClick={(e) => e.stopPropagation()} style={box}>
<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
<div>
<div style={{ fontFamily: mono, fontSize: 11, letterSpacing: '.14em', color: ORANGE, fontWeight: 700, textTransform: 'uppercase', marginBottom: 6 }}>Assinar Plano</div>
<div style={{ fontFamily: serif, fontWeight: 700, fontSize: 22, color: NAVY }}>{titulo} — {brl(preco)}/mês</div>
<div style={{ fontFamily: sans, fontSize: 13, color: GRAY, marginTop: 4 }}>Você será redirecionado ao Stripe para pagamento seguro.</div>
</div>
<button onClick={onClose} aria-label="Fechar" style={{ background: 'none', border: 'none', fontSize: 22, color: GRAY, cursor: 'pointer', lineHeight: 1 }}>×</button>
</div>
<div style={{ borderTop: '1px solid ' + LINE, margin: '16px 0 14px' }} />
{corpo}
</div>
</div>
);
}

function Card({ t, seg, onAssinar }) {
const pop = !!t[2];
const desc = seg === 'add' ? 'Adiciona o OC à sua conta RiskMind (Fechada)' : 'Somente capital aberto (CVM/B3) — não inclui empresas fechadas';
return (
<div style={{ background: '#fff', border: (pop ? '2px solid ' + NAVY : '1px solid ' + LINE), borderRadius: 10, padding: 32, display: 'flex', flexDirection: 'column', boxShadow: pop ? '0 0 12px 2px rgba(10,22,40,.14)' : 'none' }}>
{pop && <div style={{ alignSelf: 'flex-start', background: NAVY, color: CREAM, fontFamily: sans, fontSize: 11, fontWeight: 700, borderRadius: 4, padding: '3px 12px', marginBottom: 14, letterSpacing: '.02em' }}>Mais popular</div>}
<div style={{ fontFamily: serif, fontWeight: 700, fontSize: 18, color: NAVY }}>{t[0]} abertas monitoradas</div>
<div style={{ fontFamily: sans, fontSize: 12, color: GRAY, margin: '6px 0 16px', minHeight: 32 }}>{desc}</div>
<div style={{ marginBottom: 20 }}><span style={{ fontFamily: mono, fontSize: 32, fontWeight: 500, color: NAVY }}>{brl(t[1])}</span><span style={{ fontFamily: sans, fontSize: 13, color: GRAY, marginLeft: 4 }}>/mês</span></div>
<button onClick={onAssinar} style={{ textAlign: 'center', background: pop ? ORANGE : NAVY, color: '#fff', border: 'none', borderRadius: 6, padding: 12, fontFamily: sans, fontWeight: 700, fontSize: 14, marginBottom: 20, letterSpacing: '.02em', cursor: 'pointer' }}>Assinar Plano</button>
<ul style={{ padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 9 }}>{F.map((f, i) => <li key={i} style={li}><span style={{ position: 'absolute', left: 0, color: '#1a9e5c', fontWeight: 700 }}>{CK}</span>{f}</li>)}</ul>
</div>
);
}

export default function OcPlanosSection() {
const [seg, setSeg] = useState('std');
const [assinando, setAssinando] = useState(null); // plan escolhido no card
const tiers = seg === 'add' ? ADD : STD;
const tab = (on) => ({ fontFamily: sans, padding: '11px 20px', borderRadius: 6, border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: 13, background: on ? NAVY : '#efe9df', color: on ? '#fff' : GRAY });
const abrir = (t) => setAssinando((seg === 'add' ? 'addon_' : 'standalone_') + t[0]);
return (
<div>
<section style={{ background: 'linear-gradient(180deg,#0a1628 0%,#162a48 50%,#1a3f6f 100%)', color: '#fff', padding: '84px 24px' }}>
<div style={{ maxWidth: 900, margin: '0 auto', textAlign: 'center' }}>
<div style={{ display: 'inline-block', border: '1px solid rgba(200,123,42,.5)', borderRadius: 4, padding: '5px 14px', fontFamily: sans, fontSize: 12, letterSpacing: '.14em', color: ORANGE, fontWeight: 700, textTransform: 'uppercase', marginBottom: 20 }}>RiskMind OC · Capital Aberto</div>
<h2 style={{ fontFamily: serif, fontSize: 44, fontWeight: 600, margin: '0 0 16px', color: '#fff' }}>Antecipe o risco. <span style={{ color: ORANGE }}>Antes da agência.</span></h2>
<p style={{ fontFamily: sans, fontSize: 16, color: '#c3cedb', maxWidth: 760, margin: '0 auto 12px', lineHeight: 1.6 }}>O RiskMind OC monitora as <b style={{ color: '#fff' }}>companhias de capital aberto</b> (dados públicos da CVM/B3) com o mesmo motor do RiskMind: PD calibrada por múltiplas lentes, trilha comparativa com as agências (Fitch, S&P, Moody’s), análise da Mia (IA) e camada comportamental — com histórico imutável por período.</p>
<p style={{ fontFamily: sans, fontSize: 16, color: '#fff', maxWidth: 760, margin: '0 auto 28px', fontWeight: 600, lineHeight: 1.6 }}>Leitura de qualquer aberta incluída. Você contrata a profundidade — as empresas que quer monitorar de perto.</p>
<div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '10px 24px' }}>{HL.map((h, i) => <span key={i} style={{ fontFamily: sans, fontSize: 13, color: '#c3cedb' }}><span style={{ color: ORANGE, fontWeight: 700, marginRight: 6 }}>{CK}</span>{h}</span>)}</div>
</div>
</section>
<section style={{ background: CREAM, padding: '72px 24px 80px' }}>
<div style={{ maxWidth: 1080, margin: '0 auto' }}>
<div style={{ textAlign: 'center', marginBottom: 6 }}>
<h2 style={{ fontFamily: serif, fontSize: 38, fontWeight: 600, margin: '0 0 10px', color: NAVY }}>Escolha o plano para monitorar empresas de <span style={{ color: ORANGE }}>Capital Aberto</span></h2>
<p style={{ fontFamily: sans, fontSize: 15, fontWeight: 300, color: GRAY, margin: 0 }}>Contrato anual e upgrade quando precisar.</p>
</div>
<div style={{ display: 'flex', justifyContent: 'center', gap: 6, margin: '26px 0 30px' }}>
<button onClick={() => setSeg('std')} style={tab(seg === 'std')}>Standalone</button>
<button onClick={() => setSeg('add')} style={tab(seg === 'add')}>Add-on (já sou cliente)</button>
</div>
<div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 18, alignItems: 'start' }}>
{tiers.map((t, i) => <Card key={i} t={t} seg={seg} onAssinar={() => abrir(t)} />)}
<div style={{ background: NAVY, color: '#fff', borderRadius: 10, padding: 32, display: 'flex', flexDirection: 'column' }}>
<div style={{ fontFamily: serif, fontWeight: 700, fontSize: 18 }}>Enterprise</div>
<div style={{ fontFamily: sans, fontSize: 12, color: '#9fb0c3', margin: '6px 0 16px', minHeight: 32 }}>Universo completo · API · SLA</div>
<div style={{ marginBottom: 20 }}><span style={{ fontFamily: serif, fontSize: 24, fontWeight: 600, color: ORANGE }}>Sob consulta</span></div>
<a href="mailto:contato@financialmind.ai?subject=RiskMind OC Enterprise" style={{ textAlign: 'center', background: 'rgba(255,255,255,.12)', color: '#fff', border: '1px solid rgba(255,255,255,.35)', borderRadius: 6, padding: 12, fontFamily: sans, fontWeight: 700, fontSize: 14, marginBottom: 20, letterSpacing: '.02em', cursor: 'pointer', textDecoration: 'none' }}>Falar com Especialista</a>
<ul style={{ padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 9 }}>{['Universo completo da B3/CVM', 'Usuários ilimitados', 'API + ambiente dedicado', 'Modelos e relatórios sob medida', 'SLA e suporte dedicado'].map((f, i) => <li key={i} style={{ ...li, color: '#cfdae6' }}><span style={{ position: 'absolute', left: 0, color: '#4ec98a' }}>{CK}</span>{f}</li>)}</ul>
</div>
</div>
<p style={{ fontFamily: sans, textAlign: 'center', fontSize: 13, color: GRAY, marginTop: 22 }}>Contrato anual com pagamento mensal · preços em BRL · CNPJ obrigatório para emissão de NF-e.</p>
</div>
</section>
{assinando && <AssinarModal key={assinando} plan={assinando} onClose={() => setAssinando(null)} />}
</div>
);
}
